import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";

export const ExamWritingChatbotPublicSlicer = createSlice({
  name: "ExamWritingChatbotPublicSlicer",
  initialState: {} as IReduxState<IChatbotPublic>,
  reducers: {
    ExamWritingchatbotPublic: (state, _: PayloadAction<IChatbotPublic>) => {
      state.isLoading = true;
    },
    successExamWritingChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureExamWritingChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearExamWritingChatbotPublicStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  ExamWritingchatbotPublic,
  successExamWritingChatbotPublic,
  failureExamWritingChatbotPublic,
  clearExamWritingChatbotPublicStatus,
} = ExamWritingChatbotPublicSlicer.actions;

export default ExamWritingChatbotPublicSlicer.reducer;
